export default angular
  .module('doxy.common.directives.dSubmitValidation', [])
  .directive('dSubmitValidation', function ($timeout) {
    return {
      require: {
        form: '^^form',
        model: 'ngModel',
      },
      restrict: 'A',
      scope: false,
      link: function (scope, el, attrs, requireCtrl) {
        const formCtrl = requireCtrl.form;
        const ngModelCtrl = requireCtrl.model;

        const element = angular.element(el.find('input')[0] || el[0]);

        const name = attrs.name;
        const MESSAGES = {
          required: 'Required',
          email: 'Invalid email',
        };

        const showErrors = () => {
          element.next().remove();
          element.after('<span></span>');
          const errors = ngModelCtrl.$error;

          const errorKeys = Object.keys(errors);
          if (errorKeys[0]) {
            formCtrl[name].$setDirty();
          }
          errorKeys.forEach((errorKey) => {
            const message = MESSAGES[errorKey];
            if (message) {
              element
                .next()
                .append(
                  `<p class="validation-invalid" data-test-id="email-validation-error">${message}</p>`
                );
            }
          });
        };

        const clearErrors = () => {
          element.next().remove();
          formCtrl[name].$setUntouched();
          formCtrl[name].$setPristine();
        };

        element[0].onfocus = () => {
          $timeout(() => {
            clearErrors();
          });
        };
        element[0].onblur = () => {
          $timeout(() => {
            clearErrors();
          });
        };

        scope.$on('$validate', () => {
          $timeout(() => {
            showErrors();
          });
        });
      },
    };
  }).name;
